import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/auth';

@Component({
  selector: 'kt-terms-conditions',
  templateUrl: './terms-conditions.component.html',
  styleUrls: ['./terms-conditions.component.scss']
})
export class TermsConditionsComponent implements OnInit {

  eulaText: string = `𝐄𝐧𝐝 𝐔𝐬𝐞𝐫 𝐋𝐢𝐜𝐞𝐧𝐬𝐞 𝐀𝐠𝐫𝐞𝐞𝐦𝐞𝐧𝐭 (𝐄𝐔𝐋𝐀) 𝐟𝐨𝐫 𝐊𝐈𝐊𝐂𝐀𝐃 𝟐𝐃

  By accessing and using 𝐊𝐈𝐊𝐂𝐀𝐃 𝟐𝐃, you agree to the following terms and conditions:
  
  1. 𝐋𝐢𝐜𝐞𝐧𝐬𝐞 𝐆𝐫𝐚𝐧𝐭:
  • KIKBLOX grants you a non-exclusive, non-transferable license to use the software for design estimation purposes.
  
  2.𝐔𝐬𝐞 𝐚𝐭 𝐘𝐨𝐮𝐫 𝐎𝐰𝐧 𝐑𝐢𝐬𝐤:
  • The software is provided "as is." K.I.K Lanka Pvt LTD is not responsible for any errors, inaccuracies, or damages resulting from its use.
  • Please note that KIKCAD 2D is currently in beta release and may contain bugs or errors. 
    Users are advised to bear this in mind while using the software.
  
  3. 𝐈𝐧𝐭𝐞𝐥𝐥𝐞𝐜𝐭𝐮𝐚𝐥 𝐏𝐫𝐨𝐩𝐞𝐫𝐭𝐲:
  • All intellectual property rights, including copyrights, belong to KIKCAD 2D. You agree not to reproduce, distribute,
    or modify the software without explicit permission.
  
  4. 𝐃𝐚𝐭𝐚 𝐒𝐞𝐜𝐮𝐫𝐢𝐭𝐲:
  • KIKBLOX takes reasonable measures to secure your data. However, the company is not liable for any loss or unauthorized access
    to your data.
  
  5. 𝐔𝐩𝐝𝐚𝐭𝐞𝐬 𝐚𝐧𝐝 𝐒𝐮𝐩𝐩𝐨𝐫𝐭:
  • KIKBLOX may provide updates, but there is no obligation to offer ongoing support. Support availability is at the discretion 
    of the company.
  
  6. 𝐓𝐞𝐫𝐦𝐢𝐧𝐚𝐭𝐢𝐨𝐧:
  • K.I.K Lanka Pvt LTD reserves the right to terminate your access to the software at any time for violation of these terms.
  
  7. 𝐆𝐨𝐯𝐞𝐫𝐧𝐢𝐧𝐠 𝐋𝐚𝐰:
  • This agreement is governed by the laws of Sri Lanka. Any disputes shall be resolved in the courts of Sri Lanka.
  
  By using KIKCAD 2D Software, you acknowledge that you have read, understood, and agreed to be bound by these terms.
  
  Date: 19-10-2020
  
  K.I.K Lanka Pvt LTD
  
  Contact: info@kikblox.com`;

constructor(private authService: AuthService) {}

ngOnInit(): void {
  this.typeWriter();
}

typeWriter() {
  const speed = 5;
  let i = 0;

  const type = () => {
    const eulaElement = document.getElementById('eula-text');
    if (eulaElement && i < this.eulaText.length) {
      eulaElement.innerHTML += this.eulaText.charAt(i);
      i++;
      setTimeout(type, speed);
    }
  };

  type();
}

}

